import { StateCreator } from "zustand";

export type TEvaluationFilterSelection = {
  id: string;
  name: string;
};

export type TEvaluationEmployeeAttributeFilter = {
  key: string;
  value: string;
};

export type TEvaluationFilters = {
  hierarchyScope: string;
  dateType: string;
  startDate: string;
  endDate: string;
  campaign: TEvaluationFilterSelection;
  service: TEvaluationFilterSelection;
  agent: TEvaluationFilterSelection;
  searchType: string;
  searchQuery: string;
  periodValue: string;
  supervisor: TEvaluationFilterSelection;
  rankBasedAuditorId: string;
  employeeAttribute: TEvaluationEmployeeAttributeFilter;
};

export type TEvaluationStore = {
  evaluationFilters: TEvaluationFilters;
  setEvaluationFilters: (
    filters:
      TEvaluationFilters | ((prev: TEvaluationFilters) => TEvaluationFilters),
  ) => void;
};

export const createEvaluationSlice: StateCreator<
  TEvaluationStore,
  [],
  [],
  TEvaluationStore
> = (set) => ({
  evaluationFilters: {
    hierarchyScope: "",
    dateType: "call_date",
    startDate: "",
    endDate: "",
    campaign: { id: "", name: "" },
    service: { id: "", name: "" },
    agent: { id: "", name: "" },
    searchType: "ai_score",
    searchQuery: "",
    periodValue: "last-week",
    supervisor: { id: "", name: "" },
    rankBasedAuditorId: "",
    employeeAttribute: { key: "", value: "" },
  },
  setEvaluationFilters: (filters) =>
    set((state) => ({
      evaluationFilters:
        typeof filters === "function"
          ? filters(state.evaluationFilters)
          : filters,
    })),
});
